// @tg-seq: 10003
// @tg-nav: nav_tgc_000_10003_00_00_1_0000_floating_elevator_dirm
/**
 * Floating Elevator Persistent SpeedDial Floor Navigation
 *
 * ARCHITECTURE: Thin wrapper DirmFloatPattern reads pre-built manifest.
 * pattern_id: 2 (FLOAT) SpeedDial overlay from directory-navigation-manifest.json
 * Database CR2 Sequence_Num: 10003, Domain: TGC, Floor: 0, Subfloor: 0
 *
 * Created: 2026-03-20
 * Updated: 2026-03-22 manifest-driven thin wrapper
 */

import { getTsxFileName } from '../../utils/componentIdentity';
import { DirmFloatPattern } from '../ComponentTemplates/DirectoryPatterns';

const Self = () => <DirmFloatPattern seq={10003} />;
Self.displayName = getTsxFileName(import.meta.url);

export default Self;
